export default __webpack_public_path__ + "static/baby-5c07ebad56474802b2634cb5a9eda13e.jpg";